import React from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';

import { AI_COLORS } from '../aiAnalyticsConstants';

export default function AddQueryExampleDialog({ open, draft, saving, onDraftChange, onClose, onSave }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Add Query Example</DialogTitle>
      <DialogContent>
        <TextField
          label="Question"
          placeholder="How many patients were enrolled per study last quarter?"
          fullWidth
          margin="normal"
          value={draft.question}
          onChange={e => onDraftChange({ ...draft, question: e.target.value })}
        />
        <TextField
          label="Purpose (optional)"
          fullWidth
          margin="normal"
          value={draft.description}
          onChange={e => onDraftChange({ ...draft, description: e.target.value })}
        />
        <TextField
          label="SQL"
          fullWidth
          multiline
          minRows={6}
          margin="normal"
          value={draft.sql}
          onChange={e => onDraftChange({ ...draft, sql: e.target.value })}
          InputProps={{ sx: { fontFamily: 'monospace', fontSize: 13 } }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={saving || !draft.question.trim() || !draft.sql.trim()}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
          sx={{ backgroundColor: AI_COLORS.brand, '&:hover': { backgroundColor: AI_COLORS.brandDark } }}
        >
          {saving ? 'Adding…' : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
